"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.table = void 0;

var _colors = require("./colors");

var _utils = require("./utils");

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var table = {
  colors: {
    light: {
      borderedBorderColor: _colors.colors.gray300,
      stripedBackgroundColor: _colors.colors.tableStripedBackgroundColor,
      backgroundColorHoverFocus: _colors.colors.tableBackgroundColorHoverFocus,
      darkColor: _colors.colors.white,
      darkBackgroundColor: _colors.colors.gray900,
      darkBorderColor: _colors.colors.tableDarkBorderColor,
      theadDarkColor: _colors.colors.white,
      theadDarkBackgroundColor: _colors.colors.gray900,
      theadDarkBorderColor: _colors.colors.tableDarkBorderColor,
      stripedDarkBackgroundColor: _colors.colors.tableDarkStripedBackgroundColor,
      darkBackgroundColorHoverFocus: _colors.colors.tableDarkStripedBackgroundColorHoverFocus,
      theadLightColor: _colors.colors.gray700,
      theadLightBackgroundColor: _colors.colors.gray200,
      theadLightBorderColor: _colors.colors.gray300,
      borderColor: _colors.colors.gray300,
      backgroundColor: _colors.colors.white
    },
    dark: {
      borderedBorderColor: _colors.colors.gray300,
      stripedBackgroundColor: _colors.colors.tableStripedBackgroundColor,
      backgroundColorHoverFocus: _colors.colors.tableBackgroundColorHoverFocus,
      darkColor: _colors.colors.white,
      darkBackgroundColor: _colors.colors.gray900,
      darkBorderColor: _colors.colors.tableDarkBorderColor,
      theadDarkColor: _colors.colors.white,
      theadDarkBackgroundColor: _colors.colors.gray900,
      theadDarkBorderColor: _colors.colors.tableDarkBorderColor,
      stripedDarkBackgroundColor: _colors.colors.tableDarkStripedBackgroundColor,
      darkBackgroundColorHoverFocus: _colors.colors.tableDarkStripedBackgroundColorHoverFocus,
      theadLightColor: _colors.colors.gray700,
      theadLightBackgroundColor: _colors.colors.gray200,
      theadLightBorderColor: _colors.colors.gray300,
      borderColor: _colors.colors.gray300,
      backgroundColor: _colors.colors.white
    },
    default: {
      borderedBorderColor: _colors.colors.gray300,
      stripedBackgroundColor: _colors.colors.tableStripedBackgroundColor,
      backgroundColorHoverFocus: _colors.colors.tableBackgroundColorHoverFocus,
      darkColor: _colors.colors.white,
      darkBackgroundColor: _colors.colors.gray900,
      darkBorderColor: _colors.colors.tableDarkBorderColor,
      theadDarkColor: _colors.colors.white,
      theadDarkBackgroundColor: _colors.colors.gray900,
      theadDarkBorderColor: _colors.colors.tableDarkBorderColor,
      stripedDarkBackgroundColor: _colors.colors.tableDarkStripedBackgroundColor,
      darkBackgroundColorHoverFocus: _colors.colors.tableDarkStripedBackgroundColorHoverFocus,
      theadLightColor: _colors.colors.gray700,
      theadLightBackgroundColor: _colors.colors.gray200,
      theadLightBorderColor: _colors.colors.gray300,
      borderColor: _colors.colors.gray300,
      backgroundColor: _colors.colors.white
    },
    padding: {
      sm: '0.3rem'
    }
  },
  border: _objectSpread({}, _utils.utils.border, {
    bottomTop: '2px solid'
  })
};
exports.table = table;